import * as Sentry from '@sentry/react'
import { Location } from 'react-router-dom'

import authFetch from './authFetch'

export interface SessionInfo {
  id: string
  requestToken: string
  userId: string
}

export const parseQueryParams = (search: string): SessionInfo => {
  const params = new URLSearchParams(search)
  return {
    id: params.get('id') || '',
    requestToken: params.get('requestToken') || '',
    userId: params.get('userId') || '',
  }
}

const processConcurCallback = async (location: Location) => {
  const queryParams = parseQueryParams(location.search)
  try {
    await authFetch.get('concur/tokens', {
      params: queryParams,
    })
  } catch (error) {
    Sentry.captureException(error)
  }
}

export default processConcurCallback
